import React from 'react';
import './CartPage.css';

import { Button, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'

import { toast } from "react-toastify";
import ApiService from '../../services/api.service';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { translatedMessage } from '../../services/language.service';

import calogo from '../../components/shared/Resources/logo-dark-small-with-padding.png'

class CartPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artworks: [],
            author: '',
            address: {},
            countries: [],
            termsAccepted: false,
            cartId: 0,
            isLoaded: false,
            showAddressForm: false
        }
    }

    async componentDidMount() {
        try {
            const user = await ApiService.initUser();
            if (user) {
                const countries = await ApiService.getAuthenticatedInstance().get('/countries?size=1000')
                    .then(result => {
                        let res = result.data._embedded.countries.map(element => {
                            return {
                                id: element._links.self.href.split('/')[element._links.self.href.split('/').length - 1],
                                name: element.name
                            };
                        })
                        return res;
                    })
                if (!countries && countries.length === 0) {
                    throw Error("Could not get countries list");
                }

                let address = null
                if (ApiService.getCurrentProfile().address) {
                    address = ApiService.getCurrentProfile().address;
                }
                const billingAddress = this.buildBillingAddress(address, countries);

                this.setState({
                    countries: countries,
                    address: billingAddress,
                    showAddressForm: billingAddress.id === 0
                }, this.populateData)
            }
        } catch (error) {
            console.log(error);
        }
    }

    buildBillingAddress = (address, countries) => {
        var billingAddress = {}

        billingAddress.id = address !== null ? address.id : 0;
        billingAddress.address = address !== null ? address.address : '';
        billingAddress.city = address !== null ? address.city : '';
        billingAddress.zip = address !== null ? address.zip : '';
        billingAddress.country = address !== null ? address.country.id : '';
        billingAddress.countryName = address !== null ? countries.filter(item => item.id.toString() === address.country.id.toString())[0].name : '';
        billingAddress.email = ApiService.getCurrentUser().username;
        billingAddress.phone = ApiService.getCurrentProfile().phone;

        return billingAddress;
    }

    populateData = () => {
        let userId = ApiService.getCurrentUser().id;
        let cartId = 0;
        ApiService.getAuthenticatedInstance().get(`/user/userCart/${userId}`)
            .then(result => {
                cartId = result.data.id;
                ApiService.getAuthenticatedInstance().get(`/payment/cartItems/${result.data.id}`)
                    .then(result => {
                        let cartItems = result.data.filter(element => element.status === "DRAFT" && !element.isTicket)
                        let mockArtworks = [];
                        cartItems.forEach(element => {
                            let mockElement = {};

                            mockElement.cartItemId = element.id;
                            mockElement.artworkId = element.artworkId;
                            mockElement.virtualGalleryId = element.virtualGalleryId;
                            mockElement.artworkName = element.artworkName;
                            mockElement.artworkAuthor = element.authorName;
                            mockElement.publishDate = element.publishDate ? ApiService.parseDate(element.publishDate).toLocaleDateString("en-EN", { year: 'numeric', month: 'long' }) : null;
                            mockElement.artworkCategory = element.artworkCategory ? translatedMessage(element.artworkCategory) : null;
                            mockElement.virtualGalleryType = element.virtualGalleryType ? translatedMessage(element.virtualGalleryType) : null;
                            mockElement.artworkHeight = element.sizeHeight;
                            mockElement.artworkWidth = element.sizeWidth;
                            mockElement.artworkPackage = element.pricePackageName;
                            mockElement.artworkQuantity = element.quantity;
                            mockElement.price = element.price;
                            mockElement.image = element.thumbUuid ? ApiService.getFileByUuid(element.thumbUuid) : calogo;

                            mockArtworks.push(mockElement);

                            this.setState({
                                artworks: mockArtworks
                            })
                        })
                    })
                    .then(() => {
                        this.setState({
                            cartId: cartId,
                            isLoaded: true
                        })
                    })
            })
            .catch(() => {
                console.log("An error has ocurred: the cart has expired!");
                this.setState({
                    isLoaded: true
                })
            })
    }

    artworkBuyChange = (index, e) => {
        const mockArtworks = [...this.state.artworks];

        if (e.target.name === "artworkQuantity") {
            if (e.target.value) {
                if (parseInt(e.target.value) === 0) {
                    const key = e.target.name;
                    mockArtworks[index][key] = 1;

                    toast.warn(translatedMessage("CART_ITEM.QUANTITY_WARN"), { autoClose: 7000, pauseOnHover: true })
                } else {
                    const key = e.target.name;
                    const value = parseInt(e.target.value);

                    mockArtworks[index][key] = value;

                    ApiService.getAuthenticatedInstance().patch(`/cartItems/${mockArtworks[index].cartItemId}`, {
                        quantity: value,
                        lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    }).then(response => {
                        toast.success(translatedMessage("CART_ITEM.UPDATE_SUCCESS"))
                    });
                }
            } else {
                const key = e.target.name;
                mockArtworks[index][key] = "";
            }
        }

        this.setState({
            artworks: mockArtworks,
        })
    }

    removeArtwork = (index) => {
        const mockArtworks = [...this.state.artworks];

        ApiService.getAuthenticatedInstance().patch(`/cartItems/${mockArtworks[index].cartItemId}`, {
            status: 'DELETED',
            lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        })
            .then(result => {
                mockArtworks.splice(index, 1);

                this.setState({
                    artworks: mockArtworks,
                })
            })
    }

    submitBillingAddress = (e) => {
        e.preventDefault();
        let mockObjectBilling = {};
        mockObjectBilling.id = this.state.address.id;
        mockObjectBilling.address = e.target.elements.billingAddress.value;
        mockObjectBilling.city = e.target.elements.billingCity.value;
        mockObjectBilling.zip = e.target.elements.billingZip.value;
        mockObjectBilling.country = e.target.elements.billingCountry.value;
        mockObjectBilling.countryName = this.state.countries.filter(item => item.id.toString() === e.target.elements.billingCountry.value.toString())[0].name;
        mockObjectBilling.email = ApiService.getCurrentUser().username;
        mockObjectBilling.phone = e.target.elements.billingPhone.value;

        this.setState({
            address: mockObjectBilling,
        }, () => {
            const promises = [];

            if (this.state.address.id === 0) {
                promises.push(ApiService.getAuthenticatedInstance().post(`/addresses`, {
                    address: this.state.address.address,
                    city: this.state.address.city,
                    zip: this.state.address.zip,
                    country: `/countries/${this.state.address.country}`,
                    lastUpdatedBy: ApiService.getCurrentUser().username,
                    lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                }))
            } else {
                promises.push(ApiService.getAuthenticatedInstance().patch(`/addresses/${this.state.address.id}`, {
                    address: this.state.address.address,
                    city: this.state.address.city,
                    zip: this.state.address.zip,
                    country: `/countries/${this.state.address.country}`,
                    lastUpdatedBy: ApiService.getCurrentUser().username,
                    lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                }))
            }

            Promise.all(promises).then(result => {
                const billingAddressId = result[0].data._links.self.href.split("/")[result[0].data._links.self.href.split("/").length - 1];

                let profile = {
                    address: `/addresses/${billingAddressId}`,
                    phone: this.state.address.phone,
                    lastUpdatedBy: ApiService.getCurrentUser().username,
                    lastUpdatedOn: Date.now(),
                }

                ApiService.getAuthenticatedInstance().patch(`/profiles/${ApiService.getCurrentProfile().id}`, profile)
                    .then(() => {
                        ApiService.getAuthenticatedInstance().patch(`/carts/${this.state.cartId}`, {
                            billingAddress: `/addresses/${billingAddressId}`,
                        })
                            .then(result => {
                                toast.success(translatedMessage("CART.ADDRESS_SAVE_SUCCESS"));
                                this.setState({
                                    address: {
                                        ...this.state.address,
                                        id: billingAddressId
                                    },
                                    showAddressForm: false
                                })
                            })
                            .catch(error => {
                                toast.error(translatedMessage("CART.ADDRESS_SAVE_ERROR"))
                            })
                    })
            })
        })

    }

    showHideAddressForm = () => {
        this.setState({
            showAddressForm: !this.state.showAddressForm
        })
    }

    payCartItems = () => {
        let formData = new FormData();
        formData.set("cartId", this.state.cartId);
        formData.set("paymentType", "NETS");

        ApiService.getAuthenticatedInstance().post(`/payment/cart-checkout`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(result => {
            if (result.data.status === "OK") {
                toast.success(translatedMessage("CART.PAYMENT_REDIRECT"));
                window.location.href = result.data.paymentTerminalUrl;
            }
        });
    }

    payCartItemsVips = () => {
        let formData = new FormData();
        formData.set("cartId", this.state.cartId);
        formData.set("paymentType", "VIPS");

        ApiService.getAuthenticatedInstance().post(`/payment/cart-checkout`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(result => {
            if (result.data.status === "OK") {
                toast.success(translatedMessage("CART.PAYMENT_REDIRECT"));
                window.location.href = result.data.paymentTerminalUrl;
            }
        });
    }

    render() {
        let subtotal = 0;
        this.state.artworks.forEach(element => {
            subtotal += (element.price * element.artworkQuantity);
        })
        let hasAddress = this.state.address.id !== 0;
        if (!this.state.isLoaded) {
            return (
                <div className="fa-3x w-100 text-center" style={{}}>
                    <i className="fa fa-spinner fa-spin"></i>
                </div>
            )
        } else {
            if (this.state.artworks.length === 0) {
                return (
                    <div className="ca-page-padding ca-main-container">
                        <Row className="mb-3">
                            <span className="ca-page-title">{translatedMessage("GENERAL.CART")}</span>
                        </Row>
                        <Row>
                            <span className="ca-page-subtitle">{translatedMessage("CART.EMPTY")}</span>
                        </Row>
                    </div>
                )
            } else {
                return (
                    <div className="ca-page-padding ca-main-container">
                        <Row className="mb-3 pr-2">
                            <span className="ca-page-title">{translatedMessage("GENERAL.CART")}</span>
                        </Row>

                        {
                            this.state.artworks.map((element, index) => {
                                return (
                                    <Row key={index} className="ca-cart-item">
                                        <Col className="col-6 col-sm-6 col-md-8 pl-0">
                                            <Row className="d-flex align-items-center">
                                                <Col className="col-12 col-sm-6 ca-cart-photo-container">
                                                    <img
                                                        alt=""
                                                        src={element.image}
                                                        className="d-inline-block align-center ca-cart-photo"
                                                    />
                                                </Col>
                                                <Col className="col-12 col-sm-6 ca-cart-item-details-container">
                                                    <div className="cart-cart-item-title">
                                                        <span className="font-weight-bold">{element.artworkName}</span>
                                                        &nbsp;{translatedMessage("GENERAL.BY").toLowerCase()}&nbsp;
                                                        {element.artworkAuthor}
                                                    </div>

                                                    {element.artworkId &&
                                                        <div className="cart-cart-item-date">
                                                            {element.publishDate}
                                                        </div>
                                                    }

                                                    <div className="cart-cart-item-details">
                                                        {element.artworkId &&
                                                            <>
                                                                <div>{element.artworkCategory}</div>
                                                                <div>{element.artworkWidth} W x {element.artworkHeight} H cm</div>
                                                            </>
                                                        }
                                                        {element.virtualGalleryId &&
                                                            <div>{element.virtualGalleryType}</div>
                                                        }
                                                    </div>

                                                    <div className="cart-cart-item-package">
                                                        {element.artworkPackage.toUpperCase()}
                                                        &nbsp;{translatedMessage("ARTWORK.PACKAGE").toLowerCase()}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col className="col-6 col-sm-6 col-md-4 pr-0">
                                            <Row className="d-flex h-100 align-items-center mb-0">
                                                <Col className="col-12">
                                                    <div className="cart-item-quantity-container">
                                                        <div className="cart-item-quantity">
                                                            <span className="cart-item-quantity-label">{translatedMessage("GENERAL.QUANTITY")}</span>
                                                            <input
                                                                type="number"
                                                                name="artworkQuantity"
                                                                value={element.artworkQuantity}
                                                                onChange={(e) => this.artworkBuyChange(index, e)}
                                                                step="1"
                                                                min="1"
                                                            />
                                                        </div>
                                                        <div className="cart-item-remove" onClick={() => this.removeArtwork(index)}>
                                                            <span>{translatedMessage("GENERAL.REMOVE")}</span>
                                                        </div>
                                                    </div>

                                                    <div className="cart-item-price">
                                                        {ApiService.getNumberSeparatedByDots(element.price)} USD
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })
                        }

                        <div className="cart-subtotal">
                            <span className="card-price">
                                {translatedMessage("CART.SUBTOTAL")}
                            </span>
                            <span className="card-price">
                                {ApiService.getNumberSeparatedByDots(subtotal)} USD
                            </span>
                        </div>
                        <div className="cart-cart-price-details">
                            <span>
                                * {translatedMessage("CART.CHARGE_START")}&nbsp;
                                {ApiService.getNumberSeparatedByDots(subtotal)}
                                &nbsp;{translatedMessage("CART.CHARGE_END")}
                            </span>
                        </div>


                        <Row>
                            <Col className="col-12 pl-0 pr-0">
                                <div className="ca-page-subtitle font-bold mb-2">
                                    {translatedMessage("CART.ADDRESS_BILLING")}
                                    {hasAddress &&
                                        <OverlayTrigger
                                            key="editAddress"
                                            placement="bottom"
                                            overlay={
                                                <Tooltip id="tooltip-editAddress">
                                                    {translatedMessage("ADDRESS.CHANGE")}
                                                </Tooltip>
                                            }
                                        >
                                            <span style={{ fontSize: "20px", cursor: "pointer", fontWeight: "400" }} onClick={this.showHideAddressForm}>
                                                <span className="ml-2" style={{ fontFamily: "FontAwesome" }}>&#xf040;</span>
                                            </span>
                                        </OverlayTrigger>
                                    }
                                </div>

                                {hasAddress &&
                                    <div className="mb-1" style={{ fontSize: "16px" }}>
                                        <div>
                                            <span style={{ fontWeight: 700 }}>{translatedMessage("PROFILE.ADDRESS")}: </span>
                                            {this.state.address.address}, {this.state.address.city}, {this.state.address.countryName}
                                        </div>

                                        <div>
                                            <span style={{ fontWeight: 700 }}>{translatedMessage("PROFILE.PHONE")}: </span>
                                            {this.state.address.phone}
                                        </div>

                                        <div>
                                            <span style={{ fontWeight: 700 }}>{translatedMessage("PROFILE.EMAIL")}: </span>
                                            {this.state.address.email}
                                        </div>
                                    </div>
                                }

                                {this.state.showAddressForm &&
                                    <div className="mt-3 ca-form-card">
                                        <Form className="ca-form" id="addressForm" onSubmit={this.submitBillingAddress}>
                                            <Form.Group controlId="billingAddress">
                                                <Form.Label>{translatedMessage("PROFILE.ADDRESS")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    defaultValue={this.state.address.address}
                                                    placeholder={translatedMessage("PROFILE.ADDRESS_PLACEHOLDER")}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="billingZip">
                                                <Form.Label>{translatedMessage("PROFILE.ZIP")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    defaultValue={this.state.address.zip}
                                                    placeholder={translatedMessage("PROFILE.ZIP_PLACEHOLDER")}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="billingCity">
                                                <Form.Label>{translatedMessage("PROFILE.CITY")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    defaultValue={this.state.address.city}
                                                    placeholder={translatedMessage("PROFILE.CITY_PLACEHOLDER")}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="billingCountry">
                                                <Form.Label>{translatedMessage("PROFILE.COUNTRY")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    as="select"
                                                    defaultValue={
                                                        this.state.address.country ? this.state.address.country :
                                                            this.state.countries.length > 0 ? this.state.countries[163].id : 1
                                                    }
                                                >
                                                    {this.state.countries.map((country, index) => (
                                                        <option key={index} value={country.id}>{country.name}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group controlId="billingEmail">
                                                <Form.Label>{translatedMessage("PROFILE.EMAIL")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    defaultValue={this.state.address.email}
                                                    placeholder={translatedMessage("PROFILE.EMAIL_PLACEHOLDER")}
                                                />
                                            </Form.Group>

                                            <Form.Group controlId="billingPhone">
                                                <Form.Label>{translatedMessage("PROFILE.PHONE")} *</Form.Label>
                                                <Form.Control
                                                    required
                                                    defaultValue={this.state.address.phone}
                                                    placeholder={translatedMessage("PROFILE.PHONE_PLACEHOLDER")}
                                                />
                                            </Form.Group>

                                            <Button variant="dark" className="ca-button mr-1" form="addressForm" type="submit">{translatedMessage("ADDRESS.SAVE")}</Button>
                                            {hasAddress &&
                                                <Button variant="dark" className="ca-button ca-button-white" onClick={this.showHideAddressForm}>{translatedMessage("GENERAL.CLOSE")}</Button>
                                            }
                                        </Form>
                                    </div>
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col className="col-12 pl-0 mb-3">
                                <div onClick={() => this.setState({ termsAccepted: !this.state.termsAccepted })} className="ca-check-container">
                                    <input
                                        checked={this.state.termsAccepted}
                                        readOnly
                                        type="checkbox"
                                        className="d-flex align-items-center"
                                    />
                                    <span className="ca-check-label" style={{ color: "#000000" }}>
                                        {translatedMessage("TERMS.ACCEPT")}&nbsp;
                                        <a href="https://www.connected.art/tc/tos.php" target="_blank" rel="noopener noreferrer" className="ca-terms-link">
                                            {translatedMessage("TERMS.TOS")}
                                        </a>
                                    </span>
                                    <span className="ca-checkmark"></span>
                                </div>
                            </Col>
                            <Col className="col-12 pl-0 mb-2">
                                <Button variant="dark" className="ca-pay-button" onClick={this.payCartItems} disabled={!this.state.termsAccepted || this.state.address.id === 0}>
                                    {translatedMessage("CART.PAY")}  <FontAwesomeIcon className="ml-2" icon={["fas", "credit-card"]} />
                                </Button>
                                <Button variant="transparent" className="ca-vips-button" onClick={this.payCartItemsVips} disabled={!this.state.termsAccepted || this.state.address.id === 0}>
                                    <svg fill="none" height="44" viewBox="0 0 250 44" width="250" xmlns="http://www.w3.org/2000/svg"><path d="m0 22c0-12.15026 9.84973-22 22-22h206c12.15 0 22 9.84974 22 22 0 12.1503-9.85 22-22 22h-206c-12.15026 0-22-9.8497-22-22z" fill="#ff5b24" /><g fill="#fff"><path d="m52.7131 28.25c2.7822 0 4.4805-1.4092 4.4805-3.7036 0-1.6983-1.2105-2.9629-2.9629-3.1255v-.1626c1.3098-.2078 2.3215-1.4182 2.3215-2.7913 0-2.0053-1.4905-3.2519-3.9656-3.2519h-5.447v13.0349zm-3.2429-11.2192h2.5473c1.4092 0 2.2312.6775 2.2312 1.8427 0 1.1924-.8762 1.8338-2.5293 1.8338h-2.2492zm0 9.4035v-4.0739h2.6196c1.7795 0 2.719.6955 2.719 2.0234 0 1.3369-.9124 2.0505-2.6287 2.0505zm16.2675-.8852c-.3252.7407-1.093 1.1562-2.2041 1.1562-1.4724 0-2.4209-1.0478-2.4751-2.719v-.1174h6.9014v-.7136c0-3.0984-1.6892-4.9683-4.5076-4.9683-2.8635 0-4.6431 1.9963-4.6431 5.167 0 3.1616 1.7525 5.0947 4.6612 5.0947 2.3305 0 3.9836-1.1201 4.3901-2.8996zm-2.2944-5.6187c1.3459 0 2.2312.9485 2.2763 2.448h-4.6521c.0994-1.4814 1.0388-2.448 2.3758-2.448zm7.2795-3.9746v2.4841h-1.5628v1.7434h1.5628v5.4471c0 1.906.9033 2.6648 3.1706 2.6648.4336 0 .8491-.0362 1.1743-.0994v-1.7163c-.271.0271-.4426.0452-.7588.0452-.9394 0-1.3549-.4427-1.3549-1.4273v-4.9141h2.1137v-1.7434h-2.1137v-2.4841zm9.1042 12.4568c1.2917 0 2.3757-.5601 2.9267-1.5176h.1536v1.355h2.1589v-6.7478c0-2.0867-1.4272-3.3152-3.9656-3.3152-2.3486 0-3.9836 1.1021-4.1643 2.8274h2.1138c.2078-.6775.9124-1.0478 1.9421-1.0478 1.2105 0 1.8609.551 1.8609 1.5356v.8491l-2.5474.1536c-2.4028.1355-3.7488 1.1743-3.7488 2.9448 0 1.8066 1.364 2.9629 3.2701 2.9629zm.6594-1.7253c-.9937 0-1.7073-.4969-1.7073-1.346 0-.822.5872-1.2827 1.8428-1.364l2.2312-.1536v.804c0 1.1743-1.0117 2.0596-2.3667 2.0596zm7.1711 1.5627h2.2402v-13.6943h-2.2402zm9.6088 0h2.2402v-6.0071c0-1.2285.8225-2.1589 1.9335-2.1589 1.102 0 1.788.6684 1.788 1.7615v6.4045h2.177v-6.1697c0-1.1291.768-1.9963 1.933-1.9963 1.202 0 1.807.6413 1.807 1.9241v6.2419h2.231v-6.793c0-2.0505-1.192-3.27-3.171-3.27-1.373 0-2.511.7046-2.999 1.7796h-.153c-.416-1.0931-1.364-1.7796-2.728-1.7796-1.31 0-2.322.6685-2.7462 1.7796h-.1536v-1.5899h-2.1589zm23.0067-2.7009c-.326.7407-1.093 1.1562-2.205 1.1562-1.472 0-2.42-1.0478-2.475-2.719v-.1174h6.902v-.7136c0-3.0984-1.689-4.9683-4.508-4.9683-2.863 0-4.643 1.9963-4.643 5.167 0 3.1616 1.753 5.0947 4.661 5.0947 2.331 0 3.984-1.1201 4.39-2.8996zm-2.295-5.6187c1.346 0 2.231.9485 2.276 2.448h-4.652c.1-1.4814 1.039-2.448 2.376-2.448zm10.143 8.4822c1.373 0 2.511-.6414 3.071-1.7253h.154v1.5627h2.168v-13.6943h-2.24v5.3928h-.154c-.524-1.084-1.644-1.7344-2.999-1.7344-2.493 0-4.065 1.9692-4.065 5.0947 0 3.1346 1.563 5.1038 4.065 5.1038zm.696-8.3286c1.535 0 2.484 1.2375 2.484 3.2339 0 2.0053-.94 3.2339-2.484 3.2339-1.536 0-2.466-1.2105-2.466-3.2339 0-2.0144.939-3.2339 2.466-3.2339z" /><path clipRule="evenodd" d="m204.75 20.0884c-.72-2.7477-2.469-3.8384-4.855-3.8384-1.934 0-4.361 1.0907-4.361 3.7172 0 1.6968 1.173 3.0304 3.085 3.374l1.811.323c1.234.2221 1.584.6869 1.584 1.3132 0 .7071-.761 1.111-1.893 1.111-1.481 0-2.406-.5252-2.551-2.0001l-2.612.4042c.411 2.8483 2.962 4.0204 5.266 4.0204 2.181 0 4.505-1.2528 4.505-3.778 0-1.7174-1.049-2.9696-3.003-3.3337l-1.996-.3633c-1.111-.202-1.481-.7475-1.481-1.2727 0-.6668.72-1.0907 1.708-1.0907 1.255 0 2.139.4239 2.18 1.8179zm-58.075 4.3229 2.715-7.8584h3.188l-4.731 11.6565h-2.366l-4.731-11.6563h3.188zm16.683-4.5249c0 .9292-.74 1.5756-1.604 1.5756s-1.605-.6464-1.605-1.5756c0-.9294.741-1.5756 1.605-1.5756s1.605.6462 1.605 1.5756zm.494 4.1213c-1.07 1.3734-2.201 2.3229-4.197 2.323-2.036 0-3.62-1.2121-4.854-2.9897-.494-.7275-1.255-.889-1.811-.5051-.514.3637-.637 1.1314-.164 1.7982 1.707 2.5656 4.073 4.0602 6.829 4.0602 2.531 0 4.506-1.2119 6.048-3.2322.576-.7473.556-1.515 0-1.9393-.514-.4044-1.275-.2624-1.851.4849zm7.098-1.6568c0 2.384 1.399 3.6367 2.962 3.6367 1.481 0 3.004-1.1719 3.004-3.6367 0-2.4244-1.523-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.086.8281-3.888 1.9192zm13.928 4.1815c0 2.384 1.398 3.6367 2.962 3.6367 1.481 0 3.003-1.1719 3.003-3.6367 0-2.4244-1.522-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-.001-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.085.8281-3.887 1.9192z" fillRule="evenodd" /></g></svg>
                                </Button>
                            </Col>
                            <Col className="col-12 pl-0">
                                <div className="cart-review-muted-text" style={{ fontSize: "13px" }}>
                                    {translatedMessage("CART.CONFIRMATION_EMAIL")}
                                </div>
                            </Col>
                        </Row>
                    </div >
                )
            }
        }
    }
}

export default CartPage;
